import React from 'react'
import Footer from '../../components/Footer'
import "./PantallaDeSalida.css"
import { useIsMobile } from '../../hooks/useIsMobile';
const PantallaDeSalida = () => {
  const isMobile = useIsMobile(600);
  return (
    <>
        {isMobile ? 
            (<div className='info-container-img'>
                  <img src='Images/logo-azul.png' alt='Logo Medicus 50' />
            </div>) :
            (<div className='info-container-img'>
                  {/* <img src='Images/headerResponsive.png' alt='Logo Medicus 50'></img> */}
            </div>)
          }
        <div className="info-container-salida">
            <h3> ¡Realizaste la gestión con éxito! </h3>
            <p> 
                En breve recibirás un mensaje con información importante para ingresar a nuestras
                plataformas digitales y empezar a utilizar el servicio.
            </p>
        </div>
        <Footer />
    </>
  )
}

export default PantallaDeSalida
